import type { ShopPreferencesUserPortalDto } from "@babackapp/private-api-client";

/**
 * The merchant message closing a created return: the one written for returns
 * with nothing to ship when the customer keeps the item, the regular one
 * otherwise. Same choice as the legacy widget (`EndProcess.tsx`).
 */
export function resolveEndProcessTexts(
  userPortal: ShopPreferencesUserPortalDto,
  carrier: string,
) {
  return carrier === "no-physical-return"
    ? userPortal.endProcessWithoutPhysicalReturn
    : userPortal.endProcess;
}
